import type { RouteObject } from "react-router-dom";
import { lazy, Suspense, type ReactNode } from "react";

const Home = lazy(() => import("../pages/home/page"));
const Services = lazy(() => import("../pages/services/page"));
const About = lazy(() => import("../pages/about/page"));
const Contact = lazy(() => import("../pages/contact/page"));
const ThankYou = lazy(() => import("../pages/thank-you/page"));
const PrivacyPolicyPage = lazy(() => import("../pages/privacy/page"));
const TermsPage = lazy(() => import("../pages/terms/page"));
const WarehouseRackingInstallationPage = lazy(() => import("../pages/seo/warehouse-racking-installation/page"));
const WarehouseEquipmentSaudiPage = lazy(() => import("../pages/seo/warehouse-equipment-saudi/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

function RouteLoader() {
  return (
    <div className="min-h-[45vh] w-full flex items-center justify-center px-4 py-10 text-stone-500">
      <span className="inline-flex items-center gap-2 text-sm md:text-base">
        <i className="ri-loader-4-line animate-spin text-lg" />
        Loading...
      </span>
    </div>
  );
}

function withSuspense(element: ReactNode) {
  return <Suspense fallback={<RouteLoader />}>{element}</Suspense>;
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: withSuspense(<Home />),
  },
  {
    path: "/services",
    element: withSuspense(<Services />),
  },
  {
    path: "/about-us",
    element: withSuspense(<About />),
  },
  {
    path: "/contact-us",
    element: withSuspense(<Contact />),
  },
  {
    path: "/warehouse-racking-installation",
    element: withSuspense(<WarehouseRackingInstallationPage />),
  },
  {
    path: "/warehouse-equipment-saudi",
    element: withSuspense(<WarehouseEquipmentSaudiPage />),
  },
  {
    path: "/thank-you",
    element: withSuspense(<ThankYou />),
  },
  {
    path: "/privacy-policy",
    element: withSuspense(<PrivacyPolicyPage />),
  },
  {
    path: "/terms-of-service",
    element: withSuspense(<TermsPage />),
  },
  {
    path: "*",
    element: withSuspense(<NotFound />),
  },
];

export default routes;